import logo from '@kargotech/tms-common/Assets/Images/Logo/LastMile/ltms-logo.svg';
import * as lastMileConfigs from './last-mile.json';

export default {
  ...lastMileConfigs,
  logo,
  projectUrl:
    (global.location && global.location.origin) || 'https://freight.kargo.tech',
};
